import React from "react";

const OffersSection = () => {
   return (
      <section className="max-w-4xl mx-auto py-16 px-6 text-center">
         <h2 className="text-title text-dark-1 font-bold mb-8">Offres & Modalités</h2>

         <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-lg mb-10">
            <div className="p-6 flex flex-col items-center">
               <span className="text-2xl mb-2">📍</span>
               <span className="text-dark-1 font-semibold">Durée :</span> 3 à 6 mois
            </div>
            <div className="p-6 flex flex-col items-center">
               <span className="text-2xl mb-2">📚</span>
               <span className="text-dark-1 font-semibold">Mode :</span> présentiel + en ligne
            </div>
            <div className="p-6 flex flex-col items-center">
               <span className="text-2xl mb-2">🎯</span>
               <span className="text-dark-1 font-semibold">Certification :</span>
               <em>NextMaker Certified Bootcamp</em>
            </div>
         </div>

         <a href="https://app.gonextmaker.com/auth/signup">
            <button className="bg-red-4 hover:bg-white text-white hover:text-red-4 px-8 py-4 text-button
      rounded-full border-2 border-red-4 transition-colors duration-300">
               Postulez maintenant
            </button>
         </a>
      </section>
   );
};

export default OffersSection;
